import type { HelpContent } from './topics';

export type HelpLanguage = 'ru' | 'en';

// Each language is its own chunk: the guide text is only downloaded when something needs it.
const LOADERS: Record<HelpLanguage, () => Promise<{ default: HelpContent }>> = {
  ru: () => import('./content/ru'),
  en: () => import('./content/en'),
};

const cache = new Map<HelpLanguage, Promise<HelpContent>>();

/** The text of the guide in one language; the chunk is requested once and shared. */
export function loadHelpContent(language: HelpLanguage): Promise<HelpContent> {
  let pending = cache.get(language);
  if (!pending) {
    pending = LOADERS[language]().then((module) => module.default);
    // A failed download must be retried next time, not remembered.
    pending.catch(() => {
      cache.delete(language);
    });
    cache.set(language, pending);
  }
  return pending;
}

export function helpLanguageOf(language: string): HelpLanguage {
  return language.startsWith('en') ? 'en' : 'ru';
}
